// extracted by mini-css-extract-plugin
export default {"box":"Timer_box__1enRQ","box--active":"Timer_box--active__5SdQc"};